import { HeadLine } from '../../layouts/headers/HeadLine';
import CSS from 'csstype';
import './Style.css';
import CounterComponent from '../../components/counter/CounterComponent';
import GeneralButtonComponent from '../../components/button/GeneralButtonComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';
import { NoAuthAlertComponent } from '../../components/card/NoAuthAlertComponent';
import { useSelector } from 'react-redux';

export const ExperienceDetailPage = () => {

    const user = useSelector((store: any) => (store.auth));

    const checkIcon = <FontAwesomeIcon icon={faCheck} color='#67BAAF' />;
    const bgimage: CSS.Properties = { background: "url('/assets/img/experiencias_bg2.png') no-repeat center center / cover" };
    const [scrollpos, setScrollpos] = useState(316);

    const handleScroll = (e) => {

        if (e.target.scrollTop > 0) {
            setScrollpos(137);
        } else {
            setScrollpos(316);
        }

    }

    return (
        <>

            <div className='w-full absolute z-1 head-hi-sm flex flex-col justify-center'>
                <HeadLine title='Experiencias Románticas' backurl='../' />
            </div>

            <div className="w-full relative content-hi-sm">
                <div className="flex justify-center items-center" style={msgWarnStyle}>
                    <span>El cobro del servicio se realizará a tu tarjeta de crédito registrada</span>
                </div>
                <div className="bg_room_page flex justify-center items-center bg_page_top" style={bgimage}>
                    {/* <img src="/assets/img/icons/experiencias-icon.svg" alt="Icono room" /> */}
                </div>
            </div>

            <div className="absolute z-1 w-full border shadow detail-experience-container pb-4 bg_page_top"
                onScroll={handleScroll} style={{ height: `calc(100% - ${scrollpos}px)` }}>

                {
                    !user &&
                    (<div className="mt-4" style={{ marginRight: '-14px' }}>
                        <NoAuthAlertComponent />
                    </div>)
                }

                <div className='flex justify-start items-start'>
                    <span className='mr-2'>
                        <img src="/assets/img/icons/massage-icon.svg" alt="Masaje" />
                    </span>
                    <div className='flex flex-col'>
                        <span className='title mb-2'>Cena a la Orilla del Mar</span>
                        <span style={{ color: '#4B5563' }}> <strong>Lugar:</strong> Playa del Hotel</span>
                    </div>
                </div>
                <div className='flex justify-between items-center mt-4 mr-4 mt-4'>
                    <div className='flex items-center'>
                        <img src="/assets/img/icons/clock-icon.svg" alt="Clock icon" width={'25.35px'} height={'25.35px'} />
                        <span className='ml-1 type' style={timeTextStyles}>
                            <strong>Abre:</strong> 7:00 a.m.
                        </span>
                    </div>
                    <span className='type'>
                        <strong>Cierra:</strong> 7:00 p.m.
                    </span>
                </div>
                <br />
                <hr />
                <div className='mt-4' style={{ fontSize: '16px' }}>
                    Descripción:
                </div>
                <p className='mt-2'>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </p>
                <div className='mt-4 title'>Menú</div>
                <div className='mt-4'>
                    <div>
                        <span> {checkIcon} Primer tiempo:</span>
                        <p className='mt-2'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                    </div>
                    <div className='mt-4'>
                        <span>{checkIcon} Segundo tiempo:</span>
                        <p className='mt-2'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                    </div>
                    <div className='mt-4'>
                        <span>{checkIcon} Tercer tiempo:</span>
                        <p className='mt-2'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                    </div>
                </div>
                <br />
                <hr />
                <br />
                {
                    user && (

                        <div>
                            <div className='flex justify-between items-center mt-4'>
                                <span style={{ fontSize: '14px' }}>Fecha de reservación:</span>
                                <div className="inline-block relative" style={{ width: '166px' }}>
                                    <select className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded-lg shadow leading-tight focus:outline-none focus:shadow-outline"
                                        style={{ height: '50px' }}>
                                        <option>1 - Dic - 2021</option>
                                        <option>2 - Dic - 2021</option>
                                        <option>3 - Dic - 2021</option>
                                    </select>
                                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                        <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                                    </div>
                                </div>
                            </div>

                            <div className='mt-4'>
                                <span style={{ fontSize: '14px' }}>
                                    Número de Personas:
                                </span>
                                <div className='flex justify-between items-center mt-2'>
                                    <div>
                                        <CounterComponent />
                                        <span style={{ color: 'rgba(0, 0, 0, 0.5)' }}>Máximo 4 personas</span>
                                    </div>
                                    <GeneralButtonComponent classes='primary_btn hover:primary_btn text-white py-3 px-6' bgcolor='#67BAAF'> Reservar </GeneralButtonComponent>
                                </div>
                            </div>
                        </div>

                    )
                }
            </div>

        </>
    );
};

const msgWarnStyle: CSS.Properties = {
    color: '#012349',
    height: '60px',
    fontSize: '14px',
    backgroundColor: '#FFE36F',
    width: '100vw',
    paddingRight: '50px',
    paddingLeft: '50px',
    marginLeft: '-14px',
    marginTop: '-14px',
    marginBottom: '14px',
    fontWeight: '600',
    lineHeight: '14px',
    textAlign: 'center'
}

const timeTextStyles: CSS.Properties = {
    color: '#4B5563'
}
